/*

    Edit By POOM : 2024-01-26  เวลา return API    มีการใช้  status_ID === 0  ซึ่งผิด  แก้ให้ถูก คือ status_ID === 1
    Edit By POOM : 2024-05-07  
        - "ต้องเพิ่มคอลัมภ์แสดง Expenses  2 ช่อง ได้แก่ 
        - จำนวนวัน  (วางหลัง PER DIEM )
        - ระยะทาง(กม.) วางไว้หลัง ช่อง TRAVEL"

    Edit BY POOM : 09-05-2024 
        - เพิ่ม service ot เข้ามา เพราะฉนั้น ถ้าไม่มี service ot จะปิดทุกอย่างที่เกี่ยวกับ OT ออกเลย ไม่ให้บันทึกไม่ให้เห็นข้อมูล

    Edit By POOM : 13-05-2024  
        - เวลา return API  ให้เช็คว่าถ้า status_ID === 2  ให้เด้ง SessionTimeOut ทันที

*/

import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import ConfigETC from "../Class/ConfigETC.json";
import { CP_CheckPermission } from "../Class/Class_Permission"
import { Bind_Presets_Calendar,
         Bind_Select_Status,
         BootstrapTooltip,
         Return_thisWeekDate_Array,
         Class_ETC_SessionTimeOut 
       } from "../Class/Class_Etc";

import Select from "react-select";
import SelectTimeoff from "../Library/Select_Timeoff";
import SelectProjectByApprove from "../Library/Select_ProjectByApprove";
import SelectStaffByApprove from "../Library/Select_StaffByApprove";
import SelectTaskMultiGroup from "../Library/Select_TaskMultiGroup";

import { Class_ETC_MsgError
      , Class_ETC_MsgSuccess
      , Class_ETC_MsgErrorfocusByID
    } from "../Class/Class_Etc";
import MsgDescription from "../Class/MsgDescription.json";

import { DateRangePickerComponent } from '@syncfusion/ej2-react-calendars';

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { TableFooter } from "@mui/material";
import { customStylesSelect } from "../Class/Class_Etc"

import SelectCustomer from "../Library/Select_Customer";

function ApproveTimesheet() {
    //#region __ Parameter __

    const thisWeekDate = Return_thisWeekDate_Array();
    const isSVOT = CP_CheckPermission("service_list" , ["ot"],false,false);

    const [dateRange, setDateRange] = useState([thisWeekDate.DateStart_td,thisWeekDate.DateEnd_td]);
    const [startDate, endDate] = dateRange;

    const [isLoadProgress, setIsLoadProgress] = useState(true);
    const [isLoadedConfigData, setIsLoadedConfigData] = useState(false);
    const [configData, setConfigData] = useState([]);

    const dataPresets = Bind_Presets_Calendar();
    const [listdata, setListdata] = useState([]);
    const [listdetail, setListdetail] = useState([]);

    const [searchTimeoff, setSearchTimeoff] = useState(null);
    const [searchStatus , setSearchStatus] = useState([{value : ConfigETC.TS_ToReview_Value , label : ConfigETC.TS_ToReview_Text},
                                                      {value : ConfigETC.TS_ToApprove_Value , label : ConfigETC.TS_ToApprove_Text}]);
    const [searchStaff , setSearchStaff] = useState(null);
    const [searchProject, setSearchProject] = useState(null);
    const [searchTask, setSearchTask] = useState(null);

    const [iscntreset, setIscntreset] = useState(0);
    const [cntToReview, setCntToReview] = useState(0);
    const [cntToApprove, setCntToApprove] = useState(0);

    const [isStaffReject, setIsStaffReject] = useState(null);
    const [isdisabled_btnreject , setIsdisabled_btnreject] = useState(true);
    const [isdisabled_btnapprove , setIsdisabled_btnapprove] = useState(true);

    const [isValueDateS, setIsValueDateS] = useState(null);
    const [isValueDateE, setIsValueDateE] = useState(null);
    const [isValueStatus, setIsValueStatus] = useState(null);
    const [isValueProject, setIsValueProject] = useState(null);
    const [isValueTimeoff, setIsValueTimeoff] = useState(null);
    const [isValueTask, setIsValueTask] = useState(null);
    const [isValueStaff, setIsValueStaff] = useState(null);

    const [isValueCustomer, setIsValueCustomer] = useState(null);
    const [searchCustomer, setSearchCustomer] = useState(null);
    const [bindProjectBycusid, setBindProjectBycusid] = useState(0);

    //#endregion

    //#region __ HoverClass __
    function addHoverClass_approve() {
        var targetElements = document.querySelectorAll(".target-approve");

        for (let i = 0 ; i < listdata.length; i++)
        {
          try
          {
            if (document.getElementById("chk_ts_" + listdata[i].ts_id).checked === true)
            {
                document.getElementById("div_approve_" + listdata[i].ts_id).style.display = "";

                targetElements.forEach(function (element) {
                    element.classList.add("hovered");
                });
            }
            else{
                 document.getElementById("div_approve_" + listdata[i].ts_id).style.display = "none";
            }
          }
          catch{}
        }
        
       
    }

    function removeHoverClass_approve() {
        var targetElements = document.querySelectorAll(".target-approve");
        targetElements.forEach(function (element) {
            element.classList.remove("hovered");
        });
    }

    function addHoverClass_reject() {
        var targetElements = document.querySelectorAll(".target-reject");

        for (let i = 0 ; i < listdata.length; i++)
        {
          try
          {
            if (document.getElementById("chk_ts_" + listdata[i].ts_id).checked === true)
            {
                document.getElementById("div_reject_" + listdata[i].ts_id).style.display = "";

                targetElements.forEach(function (element) {
                    element.classList.add("hovered");
                });
            }
            else
            {
                document.getElementById("div_reject_" + listdata[i].ts_id).style.display = "none";
            }
          }
          catch{}
        }
      
    }

    function removeHoverClass_reject() {
        var targetElements = document.querySelectorAll(".target-reject");
        targetElements.forEach(function (element) {
            element.classList.remove("hovered");
        });
    }
    //#endregion

    //#region __ useEffect __

    useEffect(() => {
        let ckpermission = CP_CheckPermission("main" , ["approve_view"] , false , true)
        if (ckpermission === true) {
          GetConfig();
          if (isLoadedConfigData === true) {
                BindCntToReview(function() {
                    BindCntToApprove(function() {
                        // BindList('',thisWeekDate.DateStart_td,thisWeekDate.DateEnd_td,'-1','-1','','-1', function () {
                        BindList('',thisWeekDate.DateStart_ts,thisWeekDate.DateEnd_ts,'10,11','-1','-1','','-1', function () {
                            setIsLoadProgress(false);
                        });
                    });
                });
            }
        }
        // eslint-disable-next-line
    }, [isLoadedConfigData]);


    useEffect(() => {
        window.addEventListener('keydown', handleKeyDown);
        // Clean up the event listener when the component unmounts
        return () => {
          window.removeEventListener('keydown', handleKeyDown);
        };
    }, []);
    //#endregion
 
    //#region __ Function __

    async function GetConfig() {
        await fetch("../ConfigData.json")
          .then((res) => res.json())
          .then((data) => {
            setConfigData(data);
            setIsLoadedConfigData(true);
          })
          .catch((err) => err);
    }
    
    
    const handleKeyDown = (event) => {
        if (event.key === 'Escape') {
            document.getElementById("modalMoreDetail_Close").click();
            document.getElementById("modalReject_Close").click();
        }
    };

    function SearchonChangevaluesCustomer(e){
        setSearchCustomer(e)
        if (e === null)
        {
          document.getElementById("hd_cus_id_search").value = "-1";
        }
        else
        {
          document.getElementById("hd_cus_id_search").value = e.value;
        }
        setBindProjectBycusid((bindProjectBycusid) => bindProjectBycusid + 1);
        setIsLoadProgress(true);
      }

    function SearchonChangevalueproject(e){
        setSearchProject(e)
    }

    function SearchonChangevaluetimeoff(e){
        setSearchTimeoff(e)
    }

    function SearchonChangevaluestaff(e){
        setSearchStaff(e)
    }

    function SearchonChangevalueTask(e){
        setSearchTask(e)
    }

    const onChangeDateRange = (dates) => {
        if(typeof dates.value === 'undefined' || dates.value === null)
        {
            setDateRange([null,null]);
        }else{
            setDateRange(dates.value);
        }
    };

    // function default_Week() {
    //     setDateRange([new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() - new Date().getDay())
    //                 ,new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() - new Date().getDay()+6)])
    // };

    //#endregion

    //#region __ Search __
    function onclick_Search(){
        setIsLoadProgress(true);
        let ValueDateS = ""
        let ValueDateE = ""
        let ValueStatus = -1
        let ValueCustomer = -1
        let ValueProject = -1
        let ValueTimeoff = -1
        let ValueTask = ""
        let ValueStaff = ""
    
        if (searchStatus !== null) {
          ValueStatus = "";
            if (searchStatus.length > 0) {
                for (let i = 0; i < searchStatus.length; i++) {
                    ValueStatus = ValueStatus + (ValueStatus === "" ? "" : ",") + searchStatus[i].value;
                }
            }
        }
    
        if (searchCustomer !== null) {
            if (searchCustomer.value !== -1){
              ValueCustomer = searchCustomer.value.toString();
            }
            else{
              ValueCustomer = "-1"
            }
          }

        if (searchProject !== null) {
          ValueProject = searchProject.value
        }
        
    
        if (searchTimeoff !== null) {
          ValueTimeoff = searchTimeoff.value
        }

        if (searchStaff !== null) {
            ValueStaff = "";
            if (searchStaff.length > 0) {
                for (let i = 0; i < searchStaff.length; i++) {
                    ValueStaff = ValueStaff + (ValueStaff === "" ? "" : ",") + searchStaff[i].value;
                }
            }
        }

        if (searchTask !== null) {
            ValueTask = "";
            if (searchTask.length > 0) {
              for (let i = 0; i < searchTask.length; i++) {
                ValueTask = ValueTask + (ValueTask === "" ? "" : ",") + searchTask[i].value;
              }
            }
          }
    
        let date_rang = document.getElementById("txt_SearchDate").value;
        if (date_rang !== "")
        {
          let datevalue =  date_rang.split(" - ");
          if (datevalue.length === 2)
          {
            ValueDateS = datevalue[0];
            ValueDateE = datevalue[1];
          }
        }
        BindList(ValueStaff,ValueDateS,ValueDateE,ValueStatus.toString(),ValueCustomer.toString(),ValueProject.toString(),ValueTask.toString(),ValueTimeoff.toString(), function () {
            setIsLoadProgress(false);
          });
    
    
    }

    function onclick_reset(){
        setIsLoadProgress(true);
        setIscntreset((iscntreset) => iscntreset + 1)
        setSearchStatus([{value : ConfigETC.TS_ToReview_Value , label : ConfigETC.TS_ToReview_Text},
            {value : ConfigETC.TS_ToApprove_Value , label : ConfigETC.TS_ToApprove_Text}])
        // default_Week();
        setDateRange([thisWeekDate.DateStart_td,thisWeekDate.DateEnd_td]);
        BindList('',thisWeekDate.DateStart_ts,thisWeekDate.DateEnd_ts,'10,11','-1','-1','','-1', function () {
            setIsLoadProgress(false);
          });
    }

    function Bindendfunction_SP(){
        setIsLoadProgress(false)
      }

    async function BindList(ValueStaff , ValueDateStart , ValueDataEnd ,
                            ValueStatus , ValueCustomer , ValueProject , ValueTask , ValueTimeoff ,
                            _callback) {
        try {
          let token = localStorage.getItem("TStoken");
          var myHeaders = new Headers();
          myHeaders.append("Authorization", "Bearer " + token);
          myHeaders.append("Content-Type", "application/json");

          var raw = JSON.stringify({
            "staff_code": ValueStaff,
            "dateStart": ValueDateStart,
            "dateEnd": ValueDataEnd,
            "ts_status": ValueStatus,
            "cus_id": ValueCustomer,
            "pro_id": ValueProject,
            "task_id": ValueTask,
            "timeoff_id": ValueTimeoff
          });
          
          

          var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
          };
    
          const response = await fetch(
            configData.API_URL + "Approve_Getlist",
            requestOptions
          );
          const json = await response.json();
          if (json.status_ID === 1) {
            if (json.total_Data > 0) {
              setListdata(json.data);
              CB_Clear();
              setIsValueStaff(ValueStaff)
              setIsValueDateS(ValueDateStart)
              setIsValueDateE(ValueDataEnd)
              setIsValueStatus(ValueStatus)
              setIsValueCustomer(ValueCustomer)
              setIsValueProject(ValueProject)
              setIsValueTimeoff(ValueTimeoff)
              setIsValueTask(ValueTask)
              if (_callback != null) {
                _callback();
              }
            } else {
              setListdata([]);
              if (_callback != null) {
                _callback();
              }
            }
          }
          else if (json.status_ID === 2) 
          {
            Class_ETC_SessionTimeOut();
          }
          else{
            setListdata([]);
            if (_callback != null) {
              _callback();
            }
          }
        } catch {
          setListdata([]);
          if (_callback != null) {
            _callback();
          }
        }
    }

    //#endregion
      
    //#region __ checkbox __
    const onChange_CheckboxAllSubmit = (e) =>{
        const { checked } = e.target;
        CB_Submit(checked);
    }

    function CB_Submit(checked){
        
        for (let i = 0 ; i < listdata.length; i++)
        {
          try
          {
            document.getElementById("chk_ts_" + listdata[i].ts_id).checked = checked;
          }
          catch{
    
          }
        }

        if(listdata.length > 0){
            setIsdisabled_btnreject(!checked);
            setIsdisabled_btnapprove(!checked);
        }
        else{
            setIsdisabled_btnreject(true);
            setIsdisabled_btnapprove(true);
        }

    }

    function onChange_CheckboxSubmit(){
        let isck = true;
        let isoneck = false;

        for (let i = 0 ; i < listdata.length; i++)
        {
          try
          {
            if (document.getElementById("chk_ts_" + listdata[i].ts_id).checked === false)
            {
                isck = false;
            }
            else
            {
                isoneck = true;
            }
          }
          catch{}
        }
        setIsdisabled_btnreject(!isoneck);
        setIsdisabled_btnapprove(!isoneck);
        document.getElementById("chk_ts_all").checked = isck;
    }

    function CB_Clear(){
        document.getElementById("chk_ts_all").checked = false;
        CB_Submit(false)
    }
    //#endregion

    //#region __ Top Button __

    function onclickViewToReview(){
        setIsLoadProgress(true);
        setSearchStatus({value : ConfigETC.TS_ToReview_Value , label : ConfigETC.TS_ToReview_Text})
        setIscntreset(iscntreset + 1)
        setDateRange([null,null]);
        document.getElementById("ddl_ts_status").value = "10";
        document.getElementById("txt_SearchDate").value = "";
        BindList('','','','10','-1','-1','','-1', function () {
            setIsLoadProgress(false);
          });
    }

    function onclickViewToApprove(){
        setIsLoadProgress(true)
        setSearchStatus({value : ConfigETC.TS_ToApprove_Value , label : ConfigETC.TS_ToApprove_Text})
        setDateRange([null,null])
        setIscntreset(iscntreset + 1)
        document.getElementById("ddl_ts_status").value = "11";
        document.getElementById("txt_SearchDate").value = "";
        BindList('','','','11','-1','-1','','-1', function () {
            setIsLoadProgress(false);
          });
    }

    async function BindCntToReview(_callback){
        try {
    
          let token = "";
          token = localStorage.getItem("TStoken");
          var myHeaders = new Headers();
          myHeaders.append("Authorization", "Bearer " + token);
          myHeaders.append("Content-Type", "application/json");
          var requestOptions = {
            method: "POST",
            headers: myHeaders,
            redirect: "follow",
          };
    
          const response = await fetch(
            configData.API_URL + "Approve_GetCountToReview",
            requestOptions
          );
    
          const json = await response.json();
          if (json.status_ID === 1) {
            setCntToReview(json.cnt_ToReview);
            if (_callback != null) {
                _callback();
            }
          }
          else if (json.status_ID === 2) 
          {
            Class_ETC_SessionTimeOut();
          }
          else
          {
            setCntToReview(0);
            if (_callback != null) {
                _callback();
            }
          }
        } catch {
          setCntToReview(0);
          if (_callback != null) {
              _callback();
          }
        }
    }

    async function BindCntToApprove(_callback){
        try {
    
          let token = "";
          token = localStorage.getItem("TStoken");
          var myHeaders = new Headers();
          myHeaders.append("Authorization", "Bearer " + token);
          myHeaders.append("Content-Type", "application/json");
          var requestOptions = {
            method: "POST",
            headers: myHeaders,
            redirect: "follow",
          };
    
          const response = await fetch(
            configData.API_URL + "Approve_GetCountToApprove",
            requestOptions
          );
    
          const json = await response.json();
          if (json.status_ID === 1) {
            setCntToApprove(json.cnt_ToApprove);
            if (_callback != null) {
                _callback();
            }
          }
          else if (json.status_ID === 2) 
          {
            Class_ETC_SessionTimeOut();
          }
          else
          {
            setCntToApprove(0);
            if (_callback != null) {
                _callback();
            }
          }
        } catch {
            setCntToApprove(0);
          if (_callback != null) {
              _callback();
          }
        }
    }

    //#endregion

    //#region __ More Detail __

    function  onclick_MoreDetail(staff_code,staff_fullname,ts_day,ts_date) {
        setIsLoadProgress(true);
        document.getElementById("lbl_MoreDetail_Staff_Fullname").innerHTML = staff_fullname;
        document.getElementById("lbl_MoreDetail_Date").innerHTML = ts_day + "  " + ts_date;

        BindDetail(staff_code,ts_date,function(){
            setIsLoadProgress(false);
        });
    
    }

    async function BindDetail(ValueStaff , ValueDate ,_callback) {
        try {
          let token = localStorage.getItem("TStoken");
          var myHeaders = new Headers();
          myHeaders.append("Authorization", "Bearer " + token);
          myHeaders.append("Content-Type", "application/json");

          var raw = JSON.stringify({
            "staff_code": ValueStaff,
            "dateStart": ValueDate.toLocaleString(),
          });
          
          var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
          };
    
          const response = await fetch(
            configData.API_URL + "Approve_GetDetail",
            requestOptions
          );
          const json = await response.json();
          if (json.status_ID === 1) {
            if (json.total_Data > 0) {
                setListdetail(json.data);
              if (_callback != null) {
                _callback();
              }
            } else {
                setListdetail([]);
              if (_callback != null) {
                _callback();
              }
            }
          }
          else if (json.status_ID === 2) 
          {
            Class_ETC_SessionTimeOut();
          }
          else{
            setListdetail([]);
            if (_callback != null) {
                _callback();
            }
          }
        } catch {
            setListdetail([]);
            if (_callback != null) {
                _callback();
            }
        }
    }

    //#endregion

    //#region __ Save Approve/Reject __
    function onclick_Reject(){
        setIsLoadProgress(true);
        setIsStaffReject(localStorage.getItem("FullName_Eng"))
        document.getElementById("txt_reject_desc").value = ""
        let ts_id = "";
        for (let i = 0 ; i < listdata.length; i++)
        {
          try
          {
            if (document.getElementById("chk_ts_" + listdata[i].ts_id).checked === true)
            {
                ts_id = ts_id + (ts_id === "" ? "" : ",") + listdata[i].ts_id;
            }
          }
          catch{}
        }
    
        if (ts_id === "")
        {
          Class_ETC_MsgError(MsgDescription.ERR024 , null);
        }
        setIsLoadProgress(false);
    }

    function onclick_Approve(){
        setIsLoadProgress(true);
        let ts_id = "";
        let pos_auth_timesheet = 0;
        let pos_auth_timeoff = 0;

        for (let i = 0 ; i < listdata.length; i++)
        {
          try
          {
            if (document.getElementById("chk_ts_" + listdata[i].ts_id).checked === true)
            {
                ts_id = ts_id + (ts_id === "" ? "" : ",") + listdata[i].ts_id;
            }
            
          }
          catch{}
        }

        pos_auth_timesheet = listdata[0].pos_auth_timesheet;
        pos_auth_timeoff = listdata[0].pos_auth_timeoff;

        console.log(pos_auth_timesheet,'pos_auth_timesheet')
        console.log(pos_auth_timeoff,'pos_auth_timeoff')
    
        if (ts_id === "")
        {
          setIsLoadProgress(false);
          Class_ETC_MsgError(MsgDescription.ERR024 , null);
        }
        else
        {
            Save_ApproveReject(ts_id , "" , 0 , pos_auth_timesheet , pos_auth_timeoff)
        }

    }

    function onclick_SaveReject(){
        setIsLoadProgress(true);

        let istxtError = "";
        let isError = "";

        let ts_id = "";
        let ts_reject_desc = "";
        let pos_auth_timesheet = 0;
        let pos_auth_timeoff = 0;

        for (let i = 0 ; i < listdata.length; i++)
        {
          try
          {
            if (document.getElementById("chk_ts_" + listdata[i].ts_id).checked === true)
            {
                ts_id = ts_id + (ts_id === "" ? "" : ",") + listdata[i].ts_id;
            }
            
          }
          catch{}
        }
        pos_auth_timesheet = listdata[0].pos_auth_timesheet;
        pos_auth_timeoff = listdata[0].pos_auth_timeoff;
    
        ts_reject_desc = document.getElementById("txt_reject_desc").value

        if(ts_reject_desc === "")
        {
            istxtError = "txt_reject_desc"
        }

        if (ts_id === "")
        {
            istxtError = "ts_id"
            isError = "Checkbox";
        }

        if (istxtError !== "") 
        {
            isError = "Empty";
        }

        if (isError !== "") 
        {
            if (isError === "Empty") 
            {
                setIsLoadProgress(false);
                // Class_ETC_MsgError(MsgDescription.ERR024 , null);
                Class_ETC_MsgErrorfocusByID(MsgDescription.ERR001, istxtError);
            }
            else
            {
                setIsLoadProgress(false);
                Class_ETC_MsgError(MsgDescription.ERR024 , null);
            }
        }
        else
        {
            Save_ApproveReject(ts_id , ts_reject_desc , 1 , pos_auth_timesheet , pos_auth_timeoff)
        }
    
    
    }

    function Save_ApproveReject(ts_id , ts_reject_desc , is_reject , pos_auth_timesheet , pos_auth_timeoff){

        let token = localStorage.getItem("TStoken");
        var myHeaders = new Headers();
        myHeaders.append("Authorization", "Bearer " + token);
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            "ts_id": ts_id,
            "ts_reject_desc": ts_reject_desc,
            "is_reject": is_reject,
            "pos_auth_timesheet": pos_auth_timesheet,
            "pos_auth_timeoff": pos_auth_timeoff
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch(configData.API_URL + "Approve_SaveApproveReject", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.status_ID === 1) {
                    BindCntToReview(function() {
                        BindCntToApprove(function() {
                            BindList(isValueStaff,isValueDateS,isValueDateE,isValueStatus,isValueCustomer,isValueProject,isValueTask,isValueTimeoff, function () {
                                CB_Clear();
                                document.getElementById("modalReject_Close").click();
                                setIsLoadProgress(false);
                                Class_ETC_MsgSuccess(MsgDescription.CFM001, null);
                              });
                        });
                    });
                }
                else if (result.status_ID === 2) 
                {
                    Class_ETC_SessionTimeOut();
                }
                else {
                    setIsLoadProgress(false);
                    Class_ETC_MsgError(result.status_Desc, null);
                }
            })
        .catch(error => {
            setIsLoadProgress(false);
            Class_ETC_MsgError(MsgDescription.ERR002, null);
        
        });
    
    
    }

    //#endregion

  return (
    <>
     {isLoadProgress && (
        <div id="divLoadingProgress" name="divLoadingProgress" align="center" className="divWaiting" >
          <img alt="progress" src="../dist/img/loading.gif" />
        </div>
      )}

      <Helmet>
        <title>Approve Time sheet</title>
      </Helmet>

      {/* Content Wrapper. Contains page content */}
        <div className="content-wrapper">

            {/* Content Header (Page header) */}
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-9 col-md-12 col-12">
                            <div className="text-left"> 
                                <h1><i className="fas fa-chalkboard-teacher"></i> Approve Time sheet</h1>
                            </div>
                            
                                    {(cntToReview > 0 && 
                                        <>
                                            <span>
                                                <a  href="#!" 
                                                    className="btn btn-default bg-ToReview btn-sm"
                                                    onClick={onclickViewToReview}
                                                >
                                                    {/*<div className="text-smaller text-left">To Review</div>*/}
                                                    <i className="fas fa-chalkboard-teacher"></i> {/*<span className="text-bold text-biger"> 150</span>*/}
                                                    You have<span className="badge text-biger">{cntToReview}</span>to Review
                                                </a>
                                            </span>
                                        </>  
                                    )}

                                    {(cntToApprove > 0 && 
                                        <>
                                            <span>
                                                <a href="#!" 
                                                   className="btn btn-default bg-ToApprove btn-sm"
                                                   onClick={onclickViewToApprove}
                                                   >
                                                    {/*<div className="text-smaller text-left">To Approve</div>*/}
                                                    <i className="fas fa-user-check"></i> {/*<span className="text-bold text-biger"> 150</span>*/}
                                                    You have<span className="badge text-biger">{cntToApprove}</span>to Approve
                                                </a>
                                            </span>
                                        </>
                                    )}

                                
                        </div>{/* /.col */}
                        <div className="col-lg-3 col-md-12 col-12">
                                <div className="float-right">
                                    <button type="button" className="btn btn-tool" data-toggle="collapse" href="#collapseOne">
                                        <i className="fas fa-filter"></i> Filter
                                    </button>
                                </div>
                        </div>
                    </div>{/* /.row */}

                    <div className="row mt-1" id="accordion">
                        <div className="col-md-10 offset-md-1">
                            <div className="collapse" id="collapseOne" data-parent="#accordion">
                                <div className="row m-0">
                                    <div className="col-lg-4 col-12"></div>
                                    <div className="col-lg-4 col-12"> {/* Search Date */}
                                        <div className="form-group m-0">
                                            <label className="text-small p-0 m-0">Date</label>
                                            {/* <a href="#!" className="float-right text-small m-0" id="btn_this_week" onClick={onclick_Thisweek}> this week </a> */}
                                            <div className="input-group">
                                                <DateRangePickerComponent 
                                                    id="txt_SearchDate"
                                                    name="txt_SearchDate"
                                                    placeholder='Select a range' 
                                                    format='dd/MM/yyyy'
                                                    startDate={startDate}
                                                    endDate={endDate}
                                                    onChange={onChangeDateRange}
                                                    presets={dataPresets}
                                                    strictMode={true}
                                                />
                                              
                                            </div>

                                        </div>

                                    </div>
                                    <div className="col-lg-4 col-12"></div>
                                </div>
                                <div className="row m-0">
                                    <div className="col-lg-4 col-12"> {/* Search Staff */}
                                        <div className="form-group m-0">
                                            <label className="text-small p-0 m-0">Staff</label>
                                            {isLoadedConfigData && 
                                            <SelectStaffByApprove
                                                API_URL={configData.API_URL}
                                                selectismulti={true} 
                                                SelectTextDefault={ConfigETC.ddl_All}
                                                resetSelect={iscntreset}
                                                onChangevalue={SearchonChangevaluestaff}
                                                iscloseMenuOnSelect={false}
                                            ></SelectStaffByApprove>
                                            }
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-12"> {/* Search Task */}
                                        <div className="form-group">
                                            <label className="text-small p-0 m-0">Task</label>
                                            {isLoadedConfigData && 
                                                <SelectTaskMultiGroup
                                                API_URL={configData.API_URL}
                                                SelectTextDefault={ConfigETC.ddl_All}
                                                resetSelect={iscntreset}
                                                onChangevalue={SearchonChangevalueTask}
                                                iscloseMenuOnSelect={false}
                                                ></SelectTaskMultiGroup>       
                                            } 
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-12"> {/* Search Status */}
                                        <div className="form-group m-0">
                                            <label className="text-small p-0 m-0">Status</label>
                                            <Select
                                                id="ddl_ts_status"
                                                closeMenuOnSelect={false}
                                                placeholder={ConfigETC.ddl_All}
                                                value={searchStatus}
                                                isClearable={true}
                                                isMulti
                                                options={Bind_Select_Status('Approve')}
                                                menuPortalTarget={document.body}
                                                onChange={(e) => setSearchStatus(e)}
                                                 //styles={{
                                                //  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                //}}
                                                styles={customStylesSelect}
                                            />
                                        </div>


                                    </div>
                                </div>
                                <div className="row m-0">
                                    <div className="col-lg-4 col-12"> {/* Search Customer */}
                                        <div className="form-group m-0">
                                            <label className="text-small p-0 m-0">Customer</label>
                                            {isLoadedConfigData && 
                                                <SelectCustomer
                                                API_URL={configData.API_URL}
                                                cus_status={"-1"}
                                                selectismulti={false}
                                                SelectTextDefault={ConfigETC.ddl_All}
                                                resetSelect={iscntreset}
                                                onChangevalue={SearchonChangevaluesCustomer}
                                                iscloseMenuOnSelect={true}
                                            ></SelectCustomer>
                                            }
                                        </div>
                                        <input type="hidden" id="hd_cus_id_search" ></input>
                                    </div>
                                    
                                    <div className="col-lg-4 col-12"> {/* Search Project */}
                                        <div className="form-group m-0">
                                        <label className="text-small p-0 m-0">Project</label>
                                            {isLoadedConfigData && 
                                            <SelectProjectByApprove
                                                API_URL={configData.API_URL}
                                                pro_status={"-1"}
                                                staff_status={"-1"}
                                                selectismulti={false} 
                                                SelectTextDefault={ConfigETC.ddl_All}
                                                resetSelect={iscntreset}
                                                onChangevalue={SearchonChangevalueproject}
                                                iscloseMenuOnSelect={true}

                                                BindProjectBycusid={bindProjectBycusid}
                                                hd_cus_id={"hd_cus_id_search"}
                                                Bindendfunction={Bindendfunction_SP}
                                            ></SelectProjectByApprove>
                                            }
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-12">  {/* Search Time off */}
                                        <div className="form-group m-0">
                                        <label className="text-small p-0 m-0">Time off</label>
                                            {isLoadedConfigData && 
                                                <SelectTimeoff 
                                                API_URL={configData.API_URL}
                                                timeoff_status={"-1"}
                                                selectismulti={false} 
                                                SelectTextDefault={ConfigETC.ddl_All}
                                                resetSelect={iscntreset}
                                                onChangevalue={SearchonChangevaluetimeoff}
                                                iscloseMenuOnSelect={true}
                                                ></SelectTimeoff>
                                            }

                                        </div>
                                    </div>
                                </div>
                                <div className="row m-0">
                                    <div className="col-lg-4 col-12">
                                        <div className="form-group m-0">
                                            <label className="text-small p-0 m-0"></label>
                                            
                                        </div>
                                    </div>
                                    
                                    <div className="col-lg-4 col-12"> {/* Search button */}
                                        <div className="form-group m-0">
                                            <label className="text-small p-0 m-0"></label>
                                            <div className="card-tools">
                                                <button type="button" className="btn btn-primary btn-sm" onClick={onclick_Search}>
                                                    <i className="fas fa-search"></i> Search
                                                </button>
                                                <button type="button" className="btn btn-default btn-sm" onClick={onclick_reset}>
                                                    <i className="fas fa-sync-alt"></i> reset
                                                </button>

                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-12">
                                        <div className="form-group m-0">
                                            <label className="text-small p-0 m-0"></label>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>{/* /.container-fluid */}
            </div>{/* /.content-header */}

            {/* Main content */}
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                    <div className="col-md-12">
                        <div className="card shadow">
                            <div className="card-body table-responsive p-0">
                                
                                <TableContainer sx={{ maxHeight: 600 }}>
                                    <Table stickyHeader aria-label="sticky table" className="table table-head-fixed text-sm table-fit" style={{marginBottom:0}}>
                                        <TableHead >
                                            <TableRow className="table-head-fixed">
                                                <TableCell rowSpan={2} width={"2%"} align={"left"}  className="align-top"><b>#</b></TableCell>
                                                <TableCell rowSpan={2} width={"10%"} align={"left"} className="align-top"><b>Staff</b><br/><b>Position</b></TableCell>
                                                <TableCell rowSpan={2} width={"9%"} align={"left"} className="align-top"><b>Date</b></TableCell>

                                                <TableCell rowSpan={2} width={"15%"} align={"left"} className="align-top"><b>Project</b></TableCell>
                                                <TableCell rowSpan={2} width={"16%"} align={"left"} className="align-top"><b>Task/Time Off</b></TableCell>


                                                <TableCell  colSpan={2} width={"16%"} align={"center"} style={{ top: "0",height:"30px"}} 
                                                className="align-top border-right text-small" > 
                                                    <b>Timesheet </b>
                                                </TableCell>


                                                <TableCell className="align-top text-small" colSpan={5} width={"24%"} align={"center"} style={{ top: "0",height:"30px"}}>
                                                    <b>Expenses </b>
                                                </TableCell>

                                                <TableCell rowSpan={2} width={"6%"} align={"left"} className="align-top"> <b>Status</b></TableCell>

                                                <TableCell rowSpan={2} width={"2%"} align={"left"} className="align-top">
                                                    <div className="form-check">
                                                        {/* <input className="form-check-input" type="checkbox"/> */}
                                                        <input id="chk_ts_all"
                                                                   type="checkbox"
                                                                   className="form-check-input"
                                                                   onChange={onChange_CheckboxAllSubmit}
                                                            />
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                            <TableRow className="table-head-fixed">
                                                
                                                <TableCell width={"8%"} align={"center"} valign={"top"} style={{ top: 41}} 
                                                className={(isSVOT === true ? "" : "border-right")} 
                                                colSpan={(isSVOT === true ? 1 : 2)}
                                                >
                                                    <b>WT</b>
                                                </TableCell>
                                                {(isSVOT === true &&
                                                    <TableCell width={"8%"} align={"center"} style={{ top: 41}} className="border-right"><b>OT</b></TableCell>
                                                )}


                                                <TableCell width={"5%"} align={"center"} valign={"top"} style={{ top: 41}}><span className="text-smaller">Per diem allowance</span></TableCell>
                                                <TableCell width={"5%"} align={"center"} valign={"top"} style={{ top: 41}}><span className="text-smaller">Per diem allowance (day)</span></TableCell>
                                                <TableCell width={"5%"} align={"center"} style={{ top: 41}}><span className="text-smaller">Travel</span></TableCell>
                                                <TableCell width={"5%"} align={"center"} style={{ top: 41}}><span className="text-smaller">Travel distance (km.) </span></TableCell>
                                                <TableCell width={"4%"} align={"center"} style={{ top: 41, paddingRight:'0.5rem'}}><span className="text-smaller">Other</span></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody >
                                            {(listdata.length === 0 && (
                                                <TableRow key={1}>
                                                <TableCell colSpan={12} align="center">
                                                    {ConfigETC.NoData}
                                                </TableCell>
                                                </TableRow>
                                            )) ||
                                                listdata.map((row) => (
                                                <TableRow key={row.rowindex}>
                                                    <TableCell>
                                                        <div>{row.rowindex}</div>
                                                    </TableCell>
                                                    <TableCell>
                                                        <div> 
                                                            {row.staff_fullname} 
                                                            &nbsp;
                                                            <a href="#!" data-target="#modal-MoreDetail" data-toggle="modal"
                                                            className="btn btn-default btn-xs"
                                                            onClick={() =>
                                                                onclick_MoreDetail(
                                                                  row.staff_code,
                                                                  row.staff_fullname,
                                                                  row.ts_day,
                                                                  row.ts_date
                                                                )
                                                              }>
                                                            <BootstrapTooltip  title="More Transaction daily detail">
                                                               <i className="far fa-comment-dots tip text-muted"></i>
                                                            </BootstrapTooltip>
                                                            </a> 
                                                        </div>
                                                        <div className="text-muted">
                                                            {row.pos_name} 
                                                            {row.dept_name !== "" &&(
                                                                <>&nbsp;
                                                                <BootstrapTooltip title={row.dept_name}>
                                                                   <i className="fas fa-info-circle tip text-muted"></i>
                                                                </BootstrapTooltip>
                                                                </>
                                                            )}
                                                        </div>
                                                    </TableCell>
                                                    <TableCell>
                                                        <div>
                                                            <span className="text-small">{row.ts_day}</span>  {row.ts_date}
                                                        </div>
                                                    </TableCell>
                                                    <TableCell>
                                                        <div>
                                                            {row.pro_name}
                                                            {/* {row.cus_name !== "" &&(
                                                                 <>&nbsp;
                                                                <BootstrapTooltip title={"Customer : " + row.cus_name}>
                                                                    <i className="fas fa-info-circle tip text-muted"></i>
                                                                </BootstrapTooltip> 
                                                                </>
                                                            )} */}
                                                        </div>
                                                    </TableCell>
                                                    <TableCell>
                                                        <div>
                                                            {row.full_taskname !== "" &&
                                                                row.full_taskname
                                                            } 
                                                            {row.timeoff_name !== "" &&
                                                                <>
                                                                    <span className="text-italic text-muted">Time Off: </span>{row.timeoff_name}
                                                                </>
                                                            }
                                                            {row.ts_desc !== "" &&(
                                                                 <>&nbsp;
                                                                <BootstrapTooltip title={"note : " + row.ts_desc}>
                                                                    <i className="fas fa-info-circle tip text-muted"></i>
                                                                </BootstrapTooltip> 
                                                                </>
                                                            )}
                                                        </div>
                                                    </TableCell>


                                                    <TableCell colSpan={(isSVOT === true ? 1 : 2)} className={(isSVOT === true ? "text-center" : "border-right")} >
                                                        <div className="text-center"> 
                                                            {row.ts_wt_hr > 0 &&(<span>{row.ts_wt_hr}<small>h</small></span>)}
                                                            {row.ts_wt_min > 0 &&(<span> {row.ts_wt_min}<small>m</small></span>)}
                                                        </div>
                                                    </TableCell>
                                                    {isSVOT === true &&
                                                    <TableCell className="border-right" >
                                                        <div className="text-center">
                                                            {row.ts_ot_hr > 0 &&(<span>{row.ts_ot_hr}<small>h</small></span>)}
                                                            {row.ts_ot_min > 0 &&(<span> {row.ts_ot_min}<small>m</small></span>)}
                                                        </div>
                                                    </TableCell>
                                                    }

                                                    <TableCell>
                                                        <div className="text-right">
                                                            {row.ts_exp_extra === "0.00" ? "" : row.ts_exp_extra}
                                                        </div>
                                                    </TableCell>
                                                    <TableCell>
                                                        <div className="text-right">
                                                            {row.ts_exp_extra_day === "0.00" ? "" : row.ts_exp_extra_day}
                                                        </div>
                                                    </TableCell>
                                                    <TableCell>
                                                        <div className="text-right">
                                                            {row.ts_exp_travel === "0.00" ? "" : row.ts_exp_travel}
                                                        </div>
                                                    </TableCell>
                                                    <TableCell>
                                                        <div className="text-right">
                                                            {row.ts_exp_travel_distance === "0.00" ? "" : row.ts_exp_travel_distance}
                                                        </div>
                                                    </TableCell>
                                                    <TableCell>
                                                        <div className="text-right">
                                                            {row.ts_exp_other === "0.00" ? "" : row.ts_exp_other}
                                                        </div>
                                                    </TableCell>
                                                    <TableCell>
                                                        {(row.ts_status === 10 &&
                                                            <span className={"text-smaller text-left " + ConfigETC.TS_ToReview_Class} title={ConfigETC.TS_ToReview_Text}>{ConfigETC.TS_ToReview_Text}</span>
                                                        )
                                                        ||
                                                        (row.ts_status === 11 &&
                                                            <span className={"text-smaller text-left " + ConfigETC.TS_ToApprove_Class} title={ConfigETC.TS_ToApprove_Text}>{ConfigETC.TS_ToApprove_Text}</span>
                                                        )
                                                        ||
                                                        (row.ts_status === 20 &&
                                                            <span className={"text-smaller text-left " + ConfigETC.TS_Approved_Class} title={ConfigETC.TS_Approved_Text}>{ConfigETC.TS_Approved_Text}</span>
                                                        )
                                                        }
                                                        {row.ts_reject_update !== "" &&(
                                                            <>&nbsp;
                                                            <BootstrapTooltip title={"Reject Desc : "+ row.ts_reject_desc +"  | By : "+ row.ts_reject_update}>
                                                                <i className="fas fa-registered tip text-muted text-red"></i>
                                                            </BootstrapTooltip> 
                                                            </>
                                                        )}
                                                        </TableCell>
                                                    <TableCell>
                                                        <div className="form-check">
                                                            {/* <input className="form-check-input" type="checkbox"/> */}
                                                            <input
                                                                id={"chk_ts_" + row.ts_id}
                                                                type="checkbox"
                                                                className="form-check-input"
                                                                onChange={onChange_CheckboxSubmit}
                                                            />
                                                            <div id={"div_approve_" + row.ts_id} className="target-approve" style={{marginTop:"2px" , display:"none"}} >
                                                                {
                                                                    (row.ts_next_status === 1 &&
                                                                        <span className="text-smaller text-ToApprove">{row.ts_next_status_str}</span>
                                                                    )
                                                                    ||
                                                                    (row.ts_next_status !== 1 &&
                                                                        <span className="text-smaller text-Approved">{row.ts_next_status_str}</span>
                                                                    )
                                                                }
                                                            </div>
                                                            <div id={"div_reject_" + row.ts_id} className="target-reject" style={{marginTop:"2px" , display:"none"}} >
                                                                <span className="text-smaller text-danger">Reject</span>
                                                            </div>
                                                        </div>
                                                    </TableCell>
                                                </TableRow>
                                                ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <Table stickyHeader aria-label="sticky table" className="table table-head-fixed table-hover text-nowrap text-sm table-fit">
                                    <TableFooter className="card-footer">
                                        <TableRow>
                                            <TableCell width={"3%"}></TableCell>
                                            <TableCell width={"10%"}></TableCell>
                                            <TableCell width={"9%"}></TableCell>
                                            <TableCell width={"15%"}></TableCell>
                                            <TableCell width={"16%"}></TableCell>
                                            <TableCell width={"7%"}></TableCell>
                                            <TableCell width={"7%"}></TableCell>
                                            <TableCell>
                                                <div>
                                                    <div className="row">
                                                        <div className="col-lg-6 col-md-12 col-12">
                                                            <button 
                                                            className="btn btn-danger btn-block"
                                                             data-target="#modal-reject" data-toggle="modal" 
                                                                onMouseOver={(e) => addHoverClass_reject()} 
                                                                onMouseOut={(e) => removeHoverClass_reject()}
                                                                disabled={isdisabled_btnreject}
                                                                onClick={onclick_Reject}
                                                            >
                                                                <i className="far fa-calendar-times fa-lg"></i> Reject
                                                            </button>
                                                        </div>
                                                        <div className="col-lg-6 col-md-12 col-12">
                                                            <button className="btn btn-primary btn-block" 
                                                                onMouseOver={(e) => addHoverClass_approve()}
                                                                onMouseOut={(e) => removeHoverClass_approve()}
                                                                disabled={isdisabled_btnapprove}
                                                                onClick={onclick_Approve}
                                                            >
                                                                <i className="fas fa-user-check"></i> Approve/Review
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    </TableFooter>
                                </Table>
                                
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </section>
            {/* /.row (main row) */}

        </div>
        {/* /.content-wrapper */}


    {/* ###################### Modal Reject  ###################### */}

        <div className="modal fade" id="modal-reject">
        <div className="modal-dialog">
            <div className="modal-content">
                <div className="modal-header">
                    <h4 className="modal-title"><i className="far fa-calendar-times fa-lg"></i> Reject  <span className="text-sm text-muted">(input reason)</span></h4>
                    <button  id="modalReject_Close" 
                    type="button" 
                    className="close" 
                    data-dismiss="modal" 
                    aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    
                </div>

                <div className="modal-body">
                    <div className="form-horizontal ">
                        <div className="form-group row m-0">
                            <span className="text-sm col-sm-2 col-form-label">Staff</span>
                            <span className="text-sm col-sm-10 col-form-label ">
                                <span className="text-bold">
                                    <i className="fas fa-user" title="Staff"></i> {isStaffReject}
                                </span>
                            </span>
                        </div>
                    </div>
                    <div className="form-horizontal">
                        <div className="form-group  m-0">
                            <label className="text-sm  col-form-label">Reason reject<span className="text-danger">*</span></label>
                            <textarea className="form-control text-sm" id="txt_reject_desc" rows="4" placeholder="Note ..." defaultValue=""></textarea>
                        </div>
                    </div>
                </div>

                <div className="modal-footer float-right">
                    {/*<button type="button" className="btn btn-default" data-dismiss="modal">Close</button>*/}
                    <button type="button" className="btn btn-danger" onClick={onclick_SaveReject}>
                        <i className="far fa-calendar-times fa-lg"></i> Reject
                    </button>
                </div>
            </div>
        </div>
        </div>

    {/* ###################### Modal Reject  ###################### */}


    {/* ###################### Modal More Detail  ###################### */}
        
      <div className="modal fade" id="modal-MoreDetail" >
        <div className="modal-dialog modal-xl">
          <div className="modal-content" >
            <div className="modal-header">
                <h4 className="modal-title">
                    <i className="fa fa-file-o"/> <i className="far fa-comment-dots"></i> Transaction daily 
                </h4>
               

              <button
                id="modalMoreDetail_Close"
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
            <div className="container-fluid">
            <div className="row">
            <div className="col-md-6">
                        <div className="form-group">
                            <div className="text-big">Date : <label id='lbl_MoreDetail_Date'>{}</label></div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <div className="text-big">Staff : <label id='lbl_MoreDetail_Staff_Fullname'>{}</label></div>
                        </div>
                    </div>
                    
                </div>
                   
                <div className="p-0">
                    <TableContainer sx={{ maxHeight: 660 }}>
                        <Table stickyHeader aria-label="sticky table" className="table table-head-fixed table-hover text-sm table-fit" style={{marginBottom:0}}>
                            <TableHead>
                                <TableRow>
                                    <TableCell rowSpan={2} width={"2%"} align={"left"} className="align-top"><b>#</b></TableCell>
                                    <TableCell rowSpan={2} width={"15%"} align={"left"} className="align-top"><b>Project</b><br/><span className="text-muted">Position</span></TableCell>
                                    <TableCell rowSpan={2} width={"16%"} align={"left"} className="align-top"><b>Task/Time Off</b></TableCell>

                                    <TableCell colSpan={2} width={"16%"} align={"center"} className="align-top text-small border-right" style={{ top: "0",height:"30px"}}> <b>Time sheet </b></TableCell>
                                    <TableCell colSpan={5} width={"24%"} align={"center"} className="align-top text-small " style={{ top: "0",height:"30px"}}><b>Expenses </b></TableCell>

                                    <TableCell rowSpan={2} width={"6%"} align={"left"} className="align-top"> <b>Status</b></TableCell>

                                </TableRow>
                                <TableRow>

                                    <TableCell width={"8%"} align={"center"} style={{ top: 41}}
                                        colSpan={(isSVOT === true ? 1 : 2)}
                                        className={(isSVOT === true ? "" : "border-right")}
                                    >
                                        <b>WT</b>
                                    </TableCell>
                                    {isSVOT === true &&
                                        <TableCell width={"8%"} align={"center"} style={{ top: 41}} className="border-right"><b>OT</b></TableCell>
                                    }
                                    
                                    <TableCell width={"5%"} align={"right"} style={{ top: 41}}><span className="text-smaller">PER DIEM</span></TableCell>
                                    <TableCell width={"5%"} align={"center"} style={{ top: 41}}><span className="text-smaller">PER DIEM(day)</span></TableCell>
                                    <TableCell width={"5%"} align={"right"} style={{ top: 41}}><span className="text-smaller">TRAVEL</span></TableCell>
                                    <TableCell width={"5%"} align={"center"} style={{ top: 41}}><span className="text-smaller">TRAVEL distance</span></TableCell>
                                    <TableCell width={"4%"} align={"right"} style={{ top: 41, paddingRight:'0.5rem'}}><span className="text-smaller">OTHER</span></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody >
                                {(listdetail.length === 0 && (
                                    <TableRow key={1}>
                                    <TableCell colSpan={12} align="center">
                                        {ConfigETC.NoData}
                                    </TableCell>
                                    </TableRow>
                                )) ||
                                    listdetail.map((row) => (
                                    <TableRow key={row.rowindex}>
                                        <TableCell>
                                            <div>{row.rowindex}</div>
                                        </TableCell>
                                        <TableCell>
                                            <div>
                                                {row.pro_name}
                                            </div>
                                            <div className="text-muted">
                                                {row.pos_name} 
                                                {row.dept_name !== "" &&(
                                                    <>&nbsp;
                                                    <BootstrapTooltip title={row.dept_name}>
                                                        <i className="fas fa-info-circle tip text-muted"></i>
                                                    </BootstrapTooltip>
                                                    </>
                                                )}
                                            </div>
                                        </TableCell>
                                        <TableCell>
                                            <div>
                                            {row.full_taskname !== "" &&
                                                    row.full_taskname
                                                } 
                                                {row.timeoff_name !== "" &&
                                                    <>
                                                        <span className="text-italic text-muted">Time Off: </span>{row.timeoff_name}
                                                    </>
                                                }
                                                {row.ts_desc !== "" &&(
                                                        <>&nbsp;
                                                    <BootstrapTooltip title={"note : " + row.ts_desc}>
                                                        <i className="fas fa-info-circle tip text-muted"></i>
                                                    </BootstrapTooltip> 
                                                    </>
                                                )}
                                            </div>
                                        </TableCell>


                                        <TableCell className={(isSVOT === true ? "" : "border-right")} 
                                            colSpan={(isSVOT === true ? 1 : 2)}
                                        >
                                            <div className="text-center" > 
                                                {row.ts_wt_hr > 0 &&(<span>{row.ts_wt_hr}<small>h</small></span>)}
                                                {row.ts_wt_min > 0 &&(<span> {row.ts_wt_min}<small>m</small></span>)}
                                            </div>
                                        </TableCell>

                                        {isSVOT === true &&
                                            <TableCell className="border-right" >
                                                <div className="text-center">
                                                    {row.ts_ot_hr > 0 &&(<span>{row.ts_ot_hr}<small>h</small></span>)}
                                                    {row.ts_ot_min > 0 &&(<span> {row.ts_ot_min}<small>m</small></span>)}
                                                </div>
                                            </TableCell>
                                        }


                                        <TableCell>
                                            <div className="text-right">
                                                {row.ts_exp_extra === "0.00" ? "" : row.ts_exp_extra}
                                            </div>
                                        </TableCell>
                                        <TableCell>
                                            <div className="text-right">
                                                {row.ts_exp_extra_day === "0.00" ? "" : row.ts_exp_extra_day}
                                            </div>
                                        </TableCell>
                                        <TableCell>
                                            <div className="text-right">
                                                {row.ts_exp_travel === "0.00" ? "" : row.ts_exp_travel}
                                            </div>
                                        </TableCell>
                                        <TableCell>
                                            <div className="text-right">
                                                {row.ts_exp_travel_distance === "0.00" ? "" : row.ts_exp_travel_distance}
                                            </div>
                                        </TableCell>
                                        <TableCell>
                                            <div className="text-right">
                                                {row.ts_exp_other === "0.00" ? "" : row.ts_exp_other}
                                            </div>
                                        </TableCell>
                                        <TableCell>
                                            {(row.ts_status === 0 &&
                                                <span className={"text-smaller text-left " + ConfigETC.TS_InProgress_Class} title={ConfigETC.TS_InProgress_Text}>{ConfigETC.TS_InProgress_Text}</span>
                                            )
                                            ||
                                            (row.ts_status === 10 &&
                                                <span className={"text-smaller text-left " + ConfigETC.TS_ToReview_Class} title={ConfigETC.TS_ToReview_Text}>{ConfigETC.TS_ToReview_Text}</span>
                                            )
                                            ||
                                            (row.ts_status === 11 &&
                                                <span className={"text-smaller text-left " + ConfigETC.TS_ToApprove_Class} title={ConfigETC.TS_ToApprove_Text}>{ConfigETC.TS_ToApprove_Text}</span>
                                            )
                                            ||
                                            (row.ts_status === 12 &&
                                                <span className={"text-smaller text-left " + ConfigETC.TS_Reject_Class} title={ConfigETC.TS_Reject_Text}>{ConfigETC.TS_Reject_Text}</span>
                                            )
                                            ||
                                            (row.ts_status === 20 &&
                                                <span className={"text-smaller text-left " + ConfigETC.TS_Approved_Class} title={ConfigETC.TS_Approved_Text}>{ConfigETC.TS_Approved_Text}</span>
                                            )
                                            ||
                                            (row.ts_status === 30 &&
                                                <span className={"text-smaller text-left " + ConfigETC.TS_Clearing_Class} title={ConfigETC.TS_Clearing_Text}>{ConfigETC.TS_Clearing_Text}</span>
                                            )
                                            }
                                            {row.ts_reject_update !== "" &&(
                                                <>&nbsp;
                                                <BootstrapTooltip title={"Reject Desc : "+ row.ts_reject_desc +"  | By : "+ row.ts_reject_update}>
                                                    <i className="fas fa-registered tip text-muted text-red"></i>
                                                </BootstrapTooltip> 
                                                </>
                                            )}
                                            </TableCell>
                                    </TableRow>
                                    ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
                        
                </div>          

            </div>


          </div>
          {/* /.modal-content */}
        </div>
        {/* /.modal-dialog */}
      </div>
      
      {/* ###################### Modal More Detail  ###################### */}
      
    

    

    </>
  );
}

export default ApproveTimesheet;
